/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateParameterCombinationDto
 */
export interface CreateParameterCombinationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    combinationSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    hash?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateParameterCombinationDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    $type?: CreateParameterCombinationDtoTypeEnum;
}


/**
 * @export
 */
export const CreateParameterCombinationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsCreateParameterCombinationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.CreateParameterCombinationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateParameterCombinationDtoTypeEnum = typeof CreateParameterCombinationDtoTypeEnum[keyof typeof CreateParameterCombinationDtoTypeEnum];


/**
 * Check if a given object implements the CreateParameterCombinationDto interface.
 */
export function instanceOfCreateParameterCombinationDto(value?: unknown): value is CreateParameterCombinationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateParameterCombinationDtoTypeEnum)[0];
}

export function CreateParameterCombinationDtoFromJSON(json: any): CreateParameterCombinationDto {
    return CreateParameterCombinationDtoFromJSONTyped(json, false);
}

export function CreateParameterCombinationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateParameterCombinationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'combinationSetId': !exists(json, 'combinationSetId') ? undefined : json['combinationSetId'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateParameterCombinationDtoToJSON(value?: CreateParameterCombinationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combinationSetId': value.combinationSetId,
        'hash': value.hash,
        'isEnabled': value.isEnabled,
        '$type': value.$type,
    });
}

